export default __webpack_public_path__ + "static/media/pin-location.154d9232.svg";